import React from "react";

// The SVGs exported from the Figma card and its menu
// (progress/design_oko2-4205/assets), inlined so each keeps its exact path,
// stroke and fill.

const Svg = ({ children }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", flexShrink: 0 }}
  >
    {children}
  </svg>
);

const STROKE = {
  stroke: "#002E19",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const COPY_PATH =
  "M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z";

export const CopyIcon = () => (
  <Svg>
    <path d={COPY_PATH} {...STROKE} />
  </Svg>
);

// The check every copy button on Manage Groups shows once a link is copied.
export const CheckIcon = () => (
  <Svg>
    <polyline points="20 6 9 17 4 12" {...STROKE} />
  </Svg>
);

const KEBAB_FILL = "#020617";
const KEBAB_DOTS = [
  "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
  "M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z",
  "M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z",
];
const KEBAB_OUTLINE =
  "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5ZM13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z";

export const KebabIcon = () => (
  <Svg>
    {KEBAB_DOTS.map((d) => (
      <path key={d} d={d} fill={KEBAB_FILL} />
    ))}
    <path d={KEBAB_OUTLINE} {...STROKE} />
  </Svg>
);

const TRASH_PATH =
  "M3 6H21M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6M10 11V17M14 11V17";

export const TrashIcon = () => (
  <Svg>
    <path d={TRASH_PATH} {...STROKE} />
  </Svg>
);

const PENCIL_PATH =
  "M15 5L19 9M21.1739 6.81189C21.7026 6.28332 21.9997 5.56636 21.9998 4.81875C21.9999 4.07113 21.703 3.3541 21.1744 2.82539C20.6459 2.29668 19.9289 1.99961 19.1813 1.99951C18.4337 1.99942 17.7166 2.29632 17.1879 2.82489L3.84193 16.1739C3.60975 16.4054 3.43805 16.6904 3.34193 17.0039L2.02093 21.3559C1.99509 21.4424 1.99314 21.5342 2.01529 21.6217C2.03743 21.7092 2.08285 21.7891 2.14673 21.8529C2.21061 21.9167 2.29055 21.962 2.37809 21.984C2.46563 22.006 2.55749 22.0039 2.64393 21.9779L6.99693 20.6579C7.3101 20.5626 7.59511 20.392 7.82693 20.1609L21.1739 6.81189Z";

export const PencilIcon = () => (
  <Svg>
    <path d={PENCIL_PATH} {...STROKE} />
  </Svg>
);

// Edit Groups' "Add Group Code" chevron.
export const AddChevronIcon = () => (
  <Svg>
    <path d="M6 9L12 15L18 9" stroke="#524FC9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);
